import { useEffect, useRef } from 'react';
import { motion } from 'framer-motion';
import { H2 } from '../ui/Typography';

const partnerLogos = [
  { src: 'https://rentfi.b-cdn.net/coinmooner.svg', alt: 'CoinMooner Logo', width: 120, height: 50 },
  { src: 'https://rentfi.b-cdn.net/coinsniper.svg', alt: 'CoinSniper Logo', width: 120, height: 50 },
  { src: 'https://rentfi.b-cdn.net/dexscreener.svg', alt: 'DexScreener Logo', width: 120, height: 50 },
  { src: 'https://rentfi.b-cdn.net/dextools.svg', alt: 'DexTools Logo', width: 120, height: 50 },
  { src: 'https://rentfi.b-cdn.net/geckoterminal.svg', alt: 'GeckoTerminal Logo', width: 120, height: 50 },
  { src: 'https://rentfi.b-cdn.net/gemsradar.svg', alt: 'GemsRadar Logo', width: 120, height: 50 },
];

export default function PartnersSection() {
  const sliderRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const slider = sliderRef.current;
    if (!slider) return;

    const firstSet = slider.children[0].cloneNode(true) as HTMLElement;
    slider.appendChild(firstSet);
    
    const itemWidth = slider.children[0].scrollWidth;
    let position = 0;
    
    function animate() {
      position -= 1.5;
      
      if (position <= -itemWidth) {
        position = 0;
      }
      
      if (slider) {
        slider.style.transform = `translateX(${position}px)`;
      }
      requestAnimationFrame(animate);
    }

    requestAnimationFrame(animate);
  }, []);

  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-12 sm:px-16 lg:px-20">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center mb-12"
        >
          <H2 className="text-primary">Listed On</H2>
        </motion.div>

        <div className="relative overflow-hidden">
          <div 
            ref={sliderRef}
            className="flex transition-transform duration-0"
            style={{ willChange: 'transform' }}
          >
            <div className="flex items-center justify-between" style={{ width: '1200px' }}>
              {partnerLogos.map((logo, index) => (
                <div
                  key={`${logo.alt}-${index}`}
                  className="w-[160px] h-[70px] shrink-0 grayscale hover:grayscale-0 transition-all duration-300 flex items-center justify-center"
                >
                  <img
                    src={logo.src}
                    alt={logo.alt}
                    className="max-w-[120px] max-h-[48px] object-contain"
                    loading="lazy"
                    width={logo.width}
                    height={logo.height}
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}